import { useEffect } from 'react';

/** Browser title: "<Page> · Convometry". */
export function usePageTitle(page?: string) {
  useEffect(() => {
    document.title = page ? `${page} · Convometry` : 'Convometry';
  }, [page]);
}
